module.exports = __webpack_public_path__ + "img/boxing-secure-vpn.89bca350.png";